var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer3",
    d: "M12.25 6.5C13.4926 6.5 14.5 5.49264 14.5 4.25C14.5 3.00736 13.4926 2 12.25 2C11.0074 2 10 3.00736 10 4.25C10 5.49264 11.0074 6.5 12.25 6.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M12.25 23.5C13.4926 23.5 14.5 22.4926 14.5 21.25C14.5 20.0074 13.4926 19 12.25 19C11.0074 19 10 20.0074 10 21.25C10 22.4926 11.0074 23.5 12.25 23.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M12.25 15C13.4926 15 14.5 13.9926 14.5 12.75C14.5 11.5074 13.4926 10.5 12.25 10.5C11.0074 10.5 10 11.5074 10 12.75C10 13.9926 11.0074 15 12.25 15Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d15d1a313d378df8f56d76d7806be5a0.svg";
export { ForwardRef as ReactComponent };